<template>
  <div>
    <div>
      <div>
        <form
          id="file-upload-form"
          class="uploader"
          @dragover.prevent
          @drop="handleDrop"
        >
          <input
            :id="id"
            type="file"
            @change="filesSelected"
            multiple
          />
          <label
            for="file-diag"
            id="file-drag"
            class="pointer upload-file-diag"
          >
            <div>
              <img src="@/assets/images/icons/upload-cloud-2-line.svg" />
            </div>
            <p>
              {{ title }} <span style="color: red" v-if="required">*</span>
            </p>
            <!-- <p v-else>{{ fileName }}</p> -->
            <button id="file-diag-btn" @click.prevent="openFileExplorer">
              Cargar archivo
            </button>
          </label>
        </form>
      </div>
      <div v-if="files.length > 0">
        <div v-for="(item, index) in files" :key="index" class="card-file-upload-litigio mb-3">
          <div class="card-file-upload-litigio-text">
            <span>{{ item?.name }}</span>
            <p>Archivo cargado</p>
          </div>
          <button>
            <img
              class=""
              :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
              @click.prevent="removeFile(index)"
              :disabled="isBusy"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: true,
    },
    isBusy: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      files: [],
      host: process.env.VUE_APP_URL_API,
    };
  },
  methods: {
    filesSelected(event) {
      event.preventDefault();
      const me = this;
      const file = document.querySelector(`#${me.id}`);
      file.files.forEach((item, index) => {
        me.validateFile(item, index);
      });
    },
    handleDrop(event) {
      const me = this;
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      file.files.forEach((item, index) => {
        me.validateFile(item, index);
      });
    },
    openFileExplorer() {
      document.querySelector(`#${this.id}`).click();
    },
    validateFile(file) {
      const me = this;
      // if (
      //   file.type !== "application/pdf"
      // ) {
      //   me.removeFile(index)
      //   this.$bvToast.toast("El archivo debe ser .pdf", {
      //     title: "Error al subir el archivo",
      //     autoHideDelay: 3000,
      //     appendToast: true,
      //     variant: "danger",
      //     solid: true,
      //   });
      //   return false;
      // } else {
        me.files.push(file);
      // }
      me.$emit("uploadFile", me.files);
    },
    removeFile(index) {
      const me = this;
      console.log(me.files)
      me.files.splice(index, 1);
      me.$emit("uploadFile", me.files);
    },
  },
};
</script>

<style lang="scss">
.upload-file-diag {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
  align-items: center !important;
  padding: 8px !important;
  border-radius: 8px;
  position: relative;
  z-index: 8;
  margin-bottom: 30px;
}
.upload-file-diag p {
  font-size: 12px !important;
  margin-bottom: 0 !important;
  text-align: left !important;
  color: #263238 !important;
  width: 300px !important;
}
.upload-file-diag img {
  width: 32px !important;
  height: 32px !important;
}
.upload-file-diag button {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 32px;
  border-radius: 4px;
  font-size: 16px;
  border: none;
  color: white;
  padding: 6px 0px;
  width: 230px;
  justify-content: center;
}
.card-file-upload-litigio {
  display: flex;
  justify-content: space-between;
  height: 60px;
  padding: 12px 8px 12px 8px;
  border-radius: 4px;
  border: 1px solid #c6cacc;
  background-color: white;
}
.card-file-upload-litigio .card-file-upload-litigio-text {
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 12px;
  color: #263238;
}
.card-file-upload-litigio .card-file-upload-litigio-text p {
  font-size: 12px;
  color: #1719dacf;
}
.card-file-upload-litigio button {
  border: none;
  background-color: transparent;
  padding: 0;
}
.download-template {
  display: flex;
  width: 100%;
  font-size: 14px;
  color: #1719dacf;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 10px;
}

.download-template img {
  margin-right: 5px;
}
</style>
